const UseFormStateUtils = module.exports = {};

UseFormStateUtils.FORM_UI_STATE_FIELDS = [
    'submitting',
    'pageIsBlocking',
    'pageHasErrors'
];

UseFormStateUtils.buildFormUiStateDefaults = () => ({
    submitting: false,
    pageIsBlocking: false,
    pageHasErrors: false
});

UseFormStateUtils.buildInitialState = ({
    initialState,
    fallbackState
} = {}) => initialState || fallbackState;

UseFormStateUtils.shouldSyncStateDefaults = ({
    nextInitialState,
    isFormDirty
}) => !!nextInitialState && !isFormDirty;

UseFormStateUtils.getNextInitialStateForSync = ({
    props = {},
    getExplicitState = (_props) => _props.initialState,
    getFallbackSource = (_props) => _props.signupDetails,
    buildInitialState
} = {}) => {

    const explicitState = getExplicitState(props);

    if (explicitState) {
        return explicitState;
    }

    if (!getFallbackSource(props)) {
        return null;
    }

    return buildInitialState?.(props) || null;
};

UseFormStateUtils.syncInitialStateIfAllowed = ({
    props,
    isFormDirty,
    setState,
    getNextInitialState = UseFormStateUtils.getNextInitialStateForSync,
    shouldSyncStateDefaults = UseFormStateUtils.shouldSyncStateDefaults
}) => {

    const nextInitialState = getNextInitialState({ props });

    if (!shouldSyncStateDefaults({
        nextInitialState,
        isFormDirty
    })) {
        return;
    }

    setState?.(nextInitialState);
};

UseFormStateUtils.shouldSyncStateDefaultsAfterPropsChange = ({
    props,
    prevProps,
    hasSyncTriggerChanged
}) => {

    if (typeof hasSyncTriggerChanged !== 'function') {
        return false;
    }

    return hasSyncTriggerChanged(props, prevProps);
};

UseFormStateUtils.syncInitialStateAfterPropsChange = ({
    props,
    prevProps,
    isFormDirty,
    setState,
    hasSyncTriggerChanged,
    getNextInitialState,
    shouldSyncStateDefaults = UseFormStateUtils.shouldSyncStateDefaults
}) => {

    if (!UseFormStateUtils.shouldSyncStateDefaultsAfterPropsChange({
        props,
        prevProps,
        hasSyncTriggerChanged
    })) {
        return;
    }

    UseFormStateUtils.syncInitialStateIfAllowed({
        props,
        isFormDirty,
        setState,
        getNextInitialState,
        shouldSyncStateDefaults
    });
};
